<template>
  <div class="panel-body">
    <div class="">
      セルモンエージェントの各種設定を行うことができます。
      <div class="mr-t-10">
        <fieldset class="border">
          <legend class="border">FBA長期在庫</legend>
          <div class="pd-l-20 pd-r-20">
            <p class="">
              次回のAmazon請求において、FBA長期在庫追加手数料の対象商品がある場合、メールで通知を受け取ります。<br>
              毎月5日、20日時点で対象商品がある場合にのみ通知します。<br>
              プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。
            </p>
            <div class="border-bottom mr-b-10">
              <span class="text-size-20 text-primary font-bold pd-r-20">
                <i class="fa fa-pencil-square text-size-28" aria-hidden="true"></i>
                Amazon返送納品の提案を通知する
              </span>
              <toggle-button
                v-model="enableNotice"
                :labels="{checked: 'ON', unchecked: 'OFF'}"
                :height=30
                :width=62
                :sync="true"
              />
            </div>
            <div class="text-right">
              <button class="btn btn-warning w-120" @click="handleClickUpdate()" :disabled="disableUpdate">更新</button>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import SalemonAgentService from '@/services/salemonagentservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      enableNotice: true,
      loader: null
    }
  },
  computed: {
    enableAgentNotice () {
      return this.$store.getters.getUser.enableAgentNotice
    },
    disableUpdate () {
      return this.enableNotice === this.enableAgentNotice
    }
  },
  created () {
    this.enableNotice = this.enableAgentNotice
  },
  methods: {
    async handleClickUpdate () {
      let logParams = {
        name: eventCode.settings.agent_notice_tab.click_update,
        properties: { enableNotice: this.enableNotice }
      }
      EventService.postTrackLog(logParams)
      this.loader = this.$loading.show()
      await SalemonAgentService.updateSettingNotice({ enableNotice: this.enableNotice })
        .then((response) => {
          this.$store.commit('setEnableAgentNotice', this.enableNotice)
          this.$store.commit('toggleModal', {
            show: true,
            message: '更新が完了しました。'
          })
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'agent-notice') {
      let logParams = {
        name: eventCode.settings.agent_notice_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      setTimeout(() => {
        this.$events.fire('done')
      }, 500)
    }
  },
  watch: {
    enableAgentNotice () {
      this.enableNotice = this.enableAgentNotice
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.text-primary {
  color: #008cc6;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/AgentNotice.vue